/**
 * OrbDocTutorialsIntermediateCrossOrbitalENOrbDocTutorialsIntermediateCrossOrbitalENPage
 *
 * Page component for OrbDocTutorialsIntermediateCrossOrbitalENOrbDocTutorialsIntermediateCrossOrbitalENPage
 * Path: /docs/tutorials/intermediate/cross-orbital
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocTutorialsIntermediateCrossOrbitalENDocScreenView as __OrbDocTutorialsIntermediateCrossOrbitalENDocScreenView } from '@/components/traits/OrbDocTutorialsIntermediateCrossOrbitalENDocScreenView';
import { OrbDocTutorialsIntermediateCrossOrbitalENDocAnalyticsView as __OrbDocTutorialsIntermediateCrossOrbitalENDocAnalyticsView } from '@/components/traits/OrbDocTutorialsIntermediateCrossOrbitalENDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocTutorialsIntermediateCrossOrbitalENOrbDocTutorialsIntermediateCrossOrbitalENPageProps {
  // Add any page-level props here
}

export function OrbDocTutorialsIntermediateCrossOrbitalENOrbDocTutorialsIntermediateCrossOrbitalENPage(_props: OrbDocTutorialsIntermediateCrossOrbitalENOrbDocTutorialsIntermediateCrossOrbitalENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Cross-orbital events","description":"Connect two orbitals with an external event and a qualified listen, without either reaching into the other.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/tutorials/intermediate/cross-orbital"},{"locale":"ar","path":"/ar/docs/tutorials/intermediate/cross-orbital"},{"locale":"sl","path":"/sl/docs/tutorials/intermediate/cross-orbital"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocTutorialsIntermediateCrossOrbitalENDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocTutorialsIntermediateCrossOrbitalENDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocTutorialsIntermediateCrossOrbitalENOrbDocTutorialsIntermediateCrossOrbitalENPage;
